Namespace 'Settings.Models.Topics.Twitter'

class Settings.Models.Topics.Twitter.ValidateTwitterUsername extends Backbone.Model
  urlRoot: '/keepcon/topics/validate_twitter_username'

  defaults:
    username_is_valid: false
